import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { GetRootRequest, GetNodeChildrenRequest, Node, GetNodeChildrenResponse, ConsoleRequestSettings } from '../type';

export class TargetsBaseDataProvider extends BaseWebComponentDataProvider {
  public async getRootNode(request: GetRootRequest, settings: ConsoleRequestSettings): Promise<Node> {
    throw new Error('Needs to be implemented');
  }

  public async getChildNodes(
    request: GetNodeChildrenRequest,
    settings: ConsoleRequestSettings
  ): Promise<GetNodeChildrenResponse> {
    throw new Error('Needs to be implemented');
  }

  public getViewType(type: number): number {
    throw new Error('Needs to be implemented');
  }

  public isLeafNode(node: Node, userMode: boolean, showOnlyCompanies: boolean, rootNodeId: string): boolean {
    throw new Error('Needs to be implemented');
  }
}
